"use client";

import { useState, useEffect } from "react";
import * as All from "@/element/common/elmntbase";
import { AnimatePresence, motion } from "framer-motion";
import Link from "next/link";
import { useConfig } from "./ConfigProvider";
import { usePathname } from "next/navigation";

export default function SidemenuLinkWrapper() {
    const config = useConfig();
    const [open, setOpen] = useState(false);
    const [activeFMenu, setActiveFMenu] = useState<number | null>(null);
    const [activeSMenu, setActiveSMenu] = useState<number | null>(null);
    const [activlang, setActivelang] = useState<any>(null);
    const [currentMenu, setCurrentMenu] = useState<any>(null);
    const url = usePathname();

    const updateConfig = async (url: string) => {
        const url_language = url?.split("/")[1];
        if (config?.langmenu?.show_menu) {
            let _mlang = await getMatchLang(config, url_language);
            if (!_mlang) _mlang = await getMatchLang(config, "");
            setCurrentMenu(config?.menu[_mlang?.typo3Language]);
            config.activelang = _mlang;
            setActivelang(_mlang);
        } else {
            setCurrentMenu(config?.menu[0]);
            config.activelang = 0;
            setActivelang(0);
        }
    };

    const getMatchLang = async (config: any, url_language: string) => {
        const matchedLang = config?.langmenu?.langm?.find((_lm: any) => {
            const lng = _lm?.path?.split("/")[1];
            return lng === url_language;
        });
        return matchedLang || null;
    };

    useEffect(() => {
        updateConfig(url);
    }, [activlang]);

     useEffect(() => {
           let closeTimeout: NodeJS.Timeout | null = null;
   
           const updateMenuState = () => {
               const ismenuOpen = localStorage.getItem("ismenuOpen") === "true";
   
               if (ismenuOpen) {
                   if (closeTimeout) {
                       clearTimeout(closeTimeout);
                       closeTimeout = null;
                   }
                   setOpen(true);
               } else {
                   if (closeTimeout) clearTimeout(closeTimeout);
                   closeTimeout = setTimeout(() => {
                       setOpen(false);
                       setActiveFMenu(null);
                       closeTimeout = null;
                   }, 1000);
               }
           };
   
           updateMenuState();
           window.addEventListener("sidemenuToggle", updateMenuState);
           return () => {
               window.removeEventListener("sidemenuToggle", updateMenuState);
               if (closeTimeout) clearTimeout(closeTimeout);
           };
       }, []);
    const submenuVariants = {
        hidden: { height: 0, opacity: 0 },
        visible: { height: "auto", opacity: 1 },
    };
    return (
        <>
            {currentMenu?.length > 0 ? (
                <ul>
                    {currentMenu.map((menu: any, k: number) => (
                        <li key={k} className={menu?.child?.length > 0 ? "child nav-item py-2.5" : "nav-item"}>
                            <AnimatePresence>
                                <All.MotionLink
                                    href={`${menu.detail?.slug}`}
                                    className="main_link"
                                    initial={{ opacity: 1, scale: 1, visibility: "visible" }}
                                    animate={
                                        open
                                            ? { x: 0, y: 0, scale: 1, opacity: 1, transition: { delay: (k + 1) * 0.2, duration: 0.5, ease: "easeOut" } }
                                            : { x: 0, y: 0, scale: 1.3, opacity: 0, transition: { delay: 0.2, duration: 0.3, ease: "easeOut" } }
                                    }
                                >
                                    <span>{menu.title}</span>

                                    {menu?.child?.length > 0 && (
                                        <span
                                            className="n-mmneu text-xl font-bold cursor-pointer select-none ml-2" style={{ width: "57px", marginTop:"-6px" }}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                setActiveFMenu(activeFMenu === k ? null : k);
                                                setActiveSMenu(null);
                                            }}
                                        >
                                            {activeFMenu === k ? (
                                                <svg className="w-[27px] h-[27px] text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                                                    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 12h14" />
                                                </svg>
                                            ) : (
                                                <svg className="w-[27px] h-[27px] text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                                                    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 12h14m-7 7V5" />
                                                </svg>
                                            )}
                                        </span>
                                    )}
                                </All.MotionLink>
                            </AnimatePresence>

                            {/* First-level submenu */}
                            <AnimatePresence>
                                {activeFMenu === k && menu?.child?.length > 0 && (
                                    <motion.ul
                                        className="level-first dropdown-menu show fdp"
                                        initial="hidden"
                                        animate="visible"
                                        exit="hidden"
                                        variants={submenuVariants}
                                        transition={{ duration: 0.1 }}
                                    >
                                        {menu.child.map((child: any, i: number) => (
                                            <li
                                                key={child.uid}
                                                className={child?.child?.length > 0 ? "dropdown-item children chilld relative" : "dropdown-item children"}
                                            >
                                                {child?.detail?.slugurl && (
                                                    <Link className="dropdown-item sub_menu_link" href={child.detail.slugurl}>
                                                        <span>{child.detail.nav_title || child.detail.title}</span>
                                                        {child?.child?.length > 0 && (
                                                            <span
                                                                className="n-mmneu text-lg font-bold cursor-pointer select-none ml-2"
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    setActiveSMenu(activeSMenu === i ? null : i);
                                                                }}
                                                            >
                                                                {activeSMenu === i ? (
                                                                    <svg className="w-[27px] h-[27px] text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                                                                        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 12h14" />
                                                                    </svg>
                                                                ) : (
                                                                    <svg className="w-[27px] h-[27px] text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                                                                        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 12h14m-7 7V5" />
                                                                    </svg>
                                                                )}
                                                            </span>
                                                        )}
                                                    </Link>
                                                )}

                                                {/* Second-level submenu */}
                                                <AnimatePresence>
                                                    {activeSMenu === i && child?.child?.length > 0 && (
                                                        <motion.ul
                                                            className="level-sec dropdown-menu show"
                                                            initial="hidden"
                                                            animate="visible"
                                                            exit="hidden"
                                                            variants={submenuVariants}
                                                            transition={{ duration: 0.1, ease: "easeInOut" }}
                                                        >
                                                            {child.child.map((_child: any) => (
                                                                <li key={_child.uid} className="children-level p-[10px]">
                                                                    {_child.detail?.slugurl && (
                                                                        <Link className="dropdown-item sub_menu_link" href={_child.detail.slugurl}>
                                                                            <span>{_child.detail.nav_title || _child.detail.title}</span>
                                                                        </Link>
                                                                    )}
                                                                </li>
                                                            ))}
                                                        </motion.ul>

                                                    )}
                                                </AnimatePresence>
                                            </li>
                                        ))}
                                    </motion.ul>
                                )}
                            </AnimatePresence>
                        </li>
                    ))}
                </ul>
            ) : (
                <div className="text-center">Loading...</div>
            )}
        </>
    );
}










